import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import DatatableFunc from "../../Common/DatatableFunc";
import Http from "../../Common/Http";
import IsLogin from "../../Common/IsLogin";
import { LoaderComponent } from "../../Common/LoaderComponent";
import ReactDataTable from "../../Common/ReactDataTable";

const ProductWiseStock = () => {
  const location = useLocation();
  const [productData, setProductData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = () => {
    setLoading(true);
    Http.get("/product-wise-stock")
      .then((res) => {
        if (res.data.status === "success") {
          setProductData(res.data.item);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching product stock data:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const cols = [
    { field: "code", header: "Code" },
    { field: "name", header: "Name" },
    { field: "unit_name", header: "Unit" },
    { field: "category_name", header: "Category" },
    { field: "stock_qty", header: "Current Stock" },
  ];

  return (
    <div>
      <IsLogin></IsLogin>
      {loading && <LoaderComponent />}
      <div>
        <div className="am-mainpanel" style={{ marginTop: "50px" }}>
          <div className="am-pagebody">
            <div className="card pd-20 pd-sm-40">
              <h3 className="card-body-title mg-sm-b-30 text-center">
                Product Wise Current Stock
              </h3>
              <hr />
              <div className="card">
                <ReactDataTable
                  cols={cols}
                  receiveData={productData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductWiseStock;